import React from "react";
import "./SuccessDisplay.css";
import SuccessGIF from "../../../assets/img/success.gif";
import { useNavigate } from "react-router";

function SuccessDisplay({ message, action, buttonName }) {
  const navigate = useNavigate();
  return (
    <div className="success-display">
      <div className="message-content">
        <img src={SuccessGIF} alt="Success GIF" />
        <h5>{message}</h5>
        <button
          onClick={() => {
            if (action) {
              action();
            } else window?.location?.reload();
          }}
        >
          {buttonName || " Ok"}
        </button>
      </div>
    </div>
  );
}

export default SuccessDisplay;
